<template>
  <div>

    <template v-if="show === 'index'">
      <div ref="index" class="row">
        <div class="col-md-4">
          <input v-model="query.generic" class="input form-control"
                 @keypress.enter="find()"
                 placeholder="Pesquisar por Razão Social ou CNPJ">
          <search-icon @click="find()" class="icon icon-within"/>
        </div>

        <button class="col-md-2 ml-2 btn-sm btn-outline"
                style="min-height:40px;"
                :class="{ 'btn-outline-active': showFilter }"
                @click="showFilter = !showFilter">
          Filtros
          <chevron-down-icon class="fa-angle-right" :class="{ 'rotate-90': showFilter }"/>
        </button>

      </div>

      <div class="row">
        <div class="col-md-12">
          <BadgeFilters :query="query" :filters="badgesFilters"
                        @clearBadge="find()" @clearAllBadges="find()"/>
        </div>
      </div>

      <template v-if="showFilter">
        <div class="row mt-4">
          <div class="col-md-3">
            <label for="company-entity-status">Status da empresa</label>
            <select v-model="query.entityStatusId" id="company-entity-status"
                    class="browser-default custom-select"
                    @change="find()">
              <option v-for="opt in statusOptions" :key="opt.value" :value="opt.value">
                {{ opt.label }}
              </option>
            </select>
          </div>
        </div>
      </template>

      <hr>

      <Dropdown
          v-if="$withPolicy('application', 'companies/insert_or_update')"
          title-dropdown="Cadastro de empresas"
          class="btn btn-primary mr-1"
      >
        <ul class="mb-1 mt-1">
          <li
              class="dropdown-item"
              @click="createCompany"
          >
            Cadastrar empresa
          </li>
          <li
              class="dropdown-item"
              @click="openBatchModal"
          >
            Cadastrar empresas em lote
          </li>
        </ul>
      </Dropdown>

      <div class="row">
        <div class="col-md-12">
          <Table
            :companies="companies"
            @showCompany="showCompany($event)"
            @sendDeleteCompany="sendDeleteCompany"
            @error="showNotify($event)"
          />

          <div class="row">
            <div class="col-md-12 my-1">
              <Pagination
                v-model="meta.currentPage"
                :total-count="meta.totalCount"
                :total-pages="meta.totalPages"
                @pagination="pagination"
              />
            </div>
          </div>

        </div>
      </div>

    </template>

    <template v-if="show === 'show'">
      <div class="pb-3 pt-3">
        <h5>
          <strong @click="show = 'index'" style="cursor: pointer">
            <arrow-left-icon class="pb-1"/>
            Voltar para a listagem de empresas
          </strong>
        </h5>
      </div>

      <Show @deletedCompany="show = 'index'"
            @sendDeleteCompany="sendDeleteCompany"
            @editCompany="updateCompany"
            @error="showNotify"
            :company="company"/>
    </template>

    <ModalDeleteCompany v-model="showModalDeleteCompany"
                        :company="company"
                        @sendDeleteModel="deleteCompany"/>

    <Modal v-model="showModalFormCompany">
      <span slot="header">{{ titleCompanyForm }}</span>

      <FormMatrix @cancelSaveCompany="showModalFormCompany = false"
                  :company="company"
                  @saveCompany="showCompany($event)"/>
    </Modal>

    <Modal v-model="showModalBatch">
      <span slot="header">Upload de arquivo CSV</span>
      <p class="my-2">Baixe o arquivo modelo (matrizes ou filiais), preencha com as informações das empresas e faça o upload aqui.</p>
      <Upload v-if="!batchNotices.length" :isMultiple="false" accept=".csv, .CSV" @changeFiles="changeFiles">
        <h5>Clique ou arraste o arquivo CSV preenchido para cadastrar as empresas em lote</h5>
      </Upload>
      <div v-else class="batch-notices">
        <p v-for="(notice, index) in batchNotices"
           :key="index"
           class="mb-1"
           :class="{ 'text-danger': notice.startsWith('Erro') }">
          {{ notice }}
        </p>
      </div>
      <template slot="footer">
        <button
            class="btn btn-primary mt-1 mr-1"
            @click="downloadTemplate('parent')"
        >
          Baixar modelo de matrizes
        </button>
        <button
            class="btn btn-primary mt-1 mr-1"
            @click="downloadTemplate('subsidiary')"
        >
          Baixar modelo de filiais
        </button>
      </template>
    </Modal>

  </div>

</template>

<script>
  import Table from './Table'
  import FormMatrix from './FormMatrix'
  import Show from './Show'
  import Modal from '../shares/specialTag/Modal'
  import ModalDeleteCompany from '@/components/company/ModalDeleteCompany'
  import BadgeFilters from '@/components/shares/BadgeFilters'
  import { SearchIcon, ArrowLeftIcon, ChevronDownIcon } from 'vue-feather-icons'
  import Dropdown from '@/components/shares/specialTag/Dropdown.vue'
  import GetAccount from '@/mixins/GetAccount'
  import GlobalLoading from '@/mixins/GlobalLoading'
  import ModelMapper from '@/mixins/ModelMapper'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import Upload from '@/components/shares/specialTag/Upload'
  import handleSearchable from '@/models/handleSearchable'
  import { Filter } from '@/models/filter'
  import { COMPANY_STATUS, COMPANY_STATUS_OPTIONS } from '@/utils/companyStatus'

  export default {
    components: { ArrowLeftIcon, BadgeFilters, ChevronDownIcon, Dropdown, FormMatrix, Modal, ModalDeleteCompany, Pagination, SearchIcon, Show, Table, Upload },
    computed: {
      companies() {
        return this.getModels || []
      },
      statusOptions() {
        return [
          { value: '', label: 'Todos' },
          ...COMPANY_STATUS_OPTIONS.map(opt => ({ value: opt.id, label: opt.friendlyName }))
        ]
      },
      badgesFilters() {
        return [this.filterEntityStatus]
      },
    },
    created() {
      this.query.root = true
      this.$set(this.query, 'entityStatusId', COMPANY_STATUS.ENABLED)
      this.order.push('name', 'asc')
      this.methods.push('total_subsidiaries')

      this.asyncTemplateSelect()
    },
    data() {
      return {
        batchNotices: [],
        company: null,
        filterEntityStatus: new Filter({
          key: 'entityStatusId',
          label: 'Status da empresa',
          type: 'select',
          table: [
            { label: 'Ativo', value: COMPANY_STATUS.ENABLED },
            { label: 'Inativo', value: COMPANY_STATUS.DISABLED }
          ]
        }),
        nameModel: 'company',
        show: 'index',
        showModalBatch: false,
        showFilter: false,
        showModalDeleteCompany: false,
        showModalFormCompany: false,
        titleCompanyForm: ''
      }
    },
    methods: {
      buildParams(pagination) {
        if (this.query.generic)
          this.query.generic = handleSearchable(this.query.generic)

        return this.$options.superMethods.buildParams.call(this, pagination)
      },
      changeFiles(files) {
        const formData = new FormData()
        formData.append('file', files[0])

        this.openGlobalLoad()
        this.axios.post('companies/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(response => this.handleBatchResult(response.meta))
          .then(() => this.find())
          .catch(e => this.$notify.addError(e))
          .finally(() => this.closeGlobalLoad())
      },
      createCompany() {
        this.titleCompanyForm = 'Cadastrar matriz'
        this.company = { type: 'parent' }
        this.showModalFormCompany = true
      },
      downloadTemplate(type) {
        const names = { parent: 'matrizes', subsidiary: 'filiais' }
        this.axios.get(`companies/template_file/${type}`, { responseType: 'blob' })
          .then(blob => this.$parse.buildDownload(`Template - Cadastro de ${names[type]}.csv`, blob))
      },
      handleBatchResult(meta) {
        const notice = meta && meta.notice

        if (Array.isArray(notice)) {
          this.batchNotices = notice
          return
        }

        this.showModalBatch = false
        if (notice)
          this.$notify.add(notice)
      },
      openBatchModal() {
        this.batchNotices = []
        this.showModalBatch = true
      },
      deleteCompany(company) {
        this.asyncDelete(company)
          .then(() => this.showModalDeleteCompany = false)
          .then(() => this.updateCompanyInIndex())
          .catch(e => this.$notify.addError(e))
      },
      find() {
        this.asyncTemplateSelect()
      },
      sendDeleteCompany(company) {
        this.company = company
        this.showModalDeleteCompany = true
      },
      showCompany(company) {
        this.company = company
        this.show = 'show'
      },
      showNotify(messages) {
        this.$notify.addError(messages)
      },
      updateCompany(company){
        this.titleCompanyForm = 'Editar matriz'
        this.company = company
        this.showModalFormCompany = true
      },
      updateCompanyInIndex() {
        this.showModalFormCompany = false
        this.showModalDeleteCompany = false
        if (!this.$refs.index)
          this.show = 'index'
        this.find()
      },
    },
    mixins: [GetAccount, GlobalLoading, ModelMapper],
    name: 'Container',
    superMethods: {
      buildParams: ModelMapper.methods.buildParams
    },
    watch: {
      show(newValue, oldValue) {
        if (newValue === 'index' && oldValue === 'show')
          this.find()
      }
    }
  }
</script>

<style scoped>

</style>
